// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesList_wrapper__qBAKk","messagesWrapper":"MessagesList_messagesWrapper__VdiY-","messages":"MessagesList_messages__+TEdK"};